import { api } from '@/scripts/api';

const USER_CONFIG_ENDPOINT = '/ms/configs/v1/users';

export const UserConfigService = {
    async saveUserConfig(type, config) {
        const payload = {
            Type: type,
            Config: JSON.stringify(config),
        };

        return await api
            .post(USER_CONFIG_ENDPOINT, payload);
    },

    async loadUserConfig(type) {
        const endpoint = `${USER_CONFIG_ENDPOINT}?where=[{"Type": {"$eq": "${type}"}}]`;

        return await api
            .get(endpoint)
            .then(response => {
                let result = {
                    config: {},
                    data: {},
                };

                if(response.data.data && response.data.data.length !== 0) {
                    const data = response.data.data[0];
                    result.config = JSON.parse(data.Config);
                    result.data = data;
                }

                return result;
            });
    }
};